export default {
  /**
   * 获取公告列表
   **/
  getNoticeList(ctx, options = {}) {
    return ctx.$http({
      url: `/csgo/news?pageSize=${options.pageSize}&pageNo=${options.pageNo}&type=${options.type}`,
      method: 'get',
    })
  },
  /**
   * 获取公告详情
   **/
  getNoticeDetail(ctx,num) {
    return ctx.$http({
      url: `/csgo/news/${num}`,
      method: 'get',
    })
  },
}
